import { ReportBreadcrumb } from 'components/Breadcrumb'
import { LoadingSpinner } from 'components/LoadingSpinner'
import { PayoutAllStatements } from 'components/PayoutAllStatements'
import { PayoutAnalysis } from 'components/PayoutAnalysis'
import { ReportHeader } from 'components/ReportHeader'
import {
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    TabsContext,
} from 'monday-ui-react-core'
import React, { useContext, useEffect, useState } from 'react'
import { Container, Row } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { LoaderContext } from 'utils/context/LoaderContext'
import { StatementContext } from 'utils/context/StatementsContext'
import { lazy, Suspense } from 'react';
import '../../components/styles/ReportPage.scss'
import useRoles from 'hooks/useRoles'
import { PayoutOverview } from 'components/PayoutOverview'

const PayoutStatements = () => {
    const { type } = useParams()
    const { hasOverviewReportAccess, hasAnalysisReportAccess } = useRoles(type, 'PO')
    const { isLoading, setIsLoading } = useContext(LoaderContext)
    const [showModal, setShowModal] = useState(false)
    const [activeTab, setActiveTab] = useState("all")
    const [activeTabId, setActiveTabId] = useState(0)

    const [analysisTabDisabled, setAnalysisTabStatus] = useState(true)

    const [analysisPayoutFilters, setAnalysisPayoutFilters] = useState({})
    
    const [selectedStatementTypeAllStatements, setSelectedStatementTypeAllStatements] = useState({value: 0})
    
    const {
        setLastActivePage,
        receiverStatements,
        senderStatements,
        roles,
        getUserPermissionsSummary
    } = useContext(StatementContext)

    useEffect(() => {
        if (!roles.length) {
            getUserPermissionsSummary()
        }
    }, [roles])

    useEffect(() => {
        const ids = {
            'all': 0,
            'overview': 1,
            'analysis': 2
        }
        setActiveTabId(ids[activeTab])
    }, [activeTab])

    useEffect(() => {
        if (Object.keys(analysisPayoutFilters).length) {
            setAnalysisTabStatus(false)
        }
    }, [analysisPayoutFilters])

    const handleBreadcrumbClick = () => {
        if (type === "sender") {
            setLastActivePage('Sender')

            if (senderStatements === null) {
                setIsLoading(true)
            }
            else {
                setIsLoading(false)
            }
        }else
        {
            if (receiverStatements === null) {
                setIsLoading(true)
            }
            else {
                setIsLoading(false)
            }
        }
    }

    const handleTabClick = (tab) => {
        setActiveTab(tab)
    }

    const uploadButtonClick = () => {
        setShowModal(true)
    }

    const breadcrumbText = type === "receiver" ? 'Receiver Dashboard' : 'Sender Dashboard'

    const content = () => {
        return (
            <>
                <ReportBreadcrumb text={breadcrumbText} handleBreadcrumbClick={handleBreadcrumbClick} />

                {!isLoading ? (
                    <>
                        <ReportHeader isProductBalancing={false} />
                        <TabsContext
                            className="monday-storybook-tabs_bg-color tabs-dashboard pt-2"
                            activeTabId={activeTabId}
                        >
                            <div className="d-flex justify-content-between">
                                <TabList activeTabId={activeTabId}>
                                    <Tab active={activeTab === "all"} onClick={() => handleTabClick("all")} >
                                        All Statements
                                    </Tab>
                                    {
                                        hasOverviewReportAccess 
                                        ? (
                                            <Tab active={activeTab === "overview"} onClick={() => handleTabClick("overview")}>
                                                Overview
                                            </Tab>
                                        )
                                        : <></>
                                    }
                                    {
                                        hasAnalysisReportAccess 
                                        ? (
                                            <Tab active={activeTab === "analysis"} onClick={() => handleTabClick("analysis")} disabled={analysisTabDisabled}>
                                                Analysis
                                            </Tab>
                                        )
                                        : <></>
                                    }
                                    
                                </TabList>
                            </div>
                                <TabPanels activeTabId={activeTabId}>
                                    <TabPanel id="0">
                                        <PayoutAllStatements type={type} selectedStatementType={selectedStatementTypeAllStatements} setSelectedStatementType={setSelectedStatementTypeAllStatements} setAnalysisPayoutFilters={setAnalysisPayoutFilters} />
                                    </TabPanel>
                                    {
                                        hasOverviewReportAccess 
                                        ? (
                                            <TabPanel id="1">
                                                <PayoutOverview type={type} setSelectedStatementType={setSelectedStatementTypeAllStatements} setAnalysisPayoutFilters={setAnalysisPayoutFilters}/>                                                                     
                                            </TabPanel>
                                        )
                                        : <></>
                                    }
                                    {
                                        hasAnalysisReportAccess 
                                        ? (
                                            <TabPanel id="2">
                                                <PayoutAnalysis type={type} analysisPayoutFilters={analysisPayoutFilters} setAnalysisPayoutFilters={setAnalysisPayoutFilters} setActiveTab={setActiveTab} />
                                            </TabPanel>
                                        )
                                        : <></>
                                    }
                                </TabPanels>
                        </TabsContext>                
                    </>
                ) : <LoadingSpinner />
                }
            </>
        )
    }

    return (
        <Container className="reports-container">
            <Row>
                {content()}
            </Row>
        </Container>
    )
}

export default PayoutStatements